import { render, staticRenderFns } from "./PaginateComponent.vue?vue&type=template&id=1b7d02b6&"
import script from "./PaginateComponent.vue?vue&type=script&lang=js&"
export * from "./PaginateComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaginateComponent.vue?vue&type=style&index=0&id=1b7d02b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports